export const TYPE_ERROR = 'error';
export const TYPE_PROGRESS = 'progress';
export const TYPE_SUCCESS = 'success';
